import React from 'react';

import { OrdersSummaryProps } from './OrdersSummary.props';

import OrdersSummaryView from './OrdersSummary.view';

const OrdersSummaryContainer = (_props: OrdersSummaryProps) => {
  return <OrdersSummaryView />;
};

export default OrdersSummaryContainer;
